<form [formGroup]="form.formGroup">

  <p-toolbar>
    <ng-template #start></ng-template>
    <ng-template #end>
      <div class="flex items-center">
        <svg-icon
          src="../../assets/icons/reset-default-24x24.svg"
          class="w-[25px] h-[25px] tree-icon cursor-pointer"
          (click)="applyDefaults()"
          title="Apply Defaults">
        </svg-icon>
      </div>
    </ng-template>
  </p-toolbar>


  <div class="flex flex-wrap mt-2">

    <div class="flex flex-col w-1/2 p-2 space-y-2">

      <div class="flex flex-col">
        <label for="baseFluid">Base Fluid</label>
        <p-select
          id="baseFluid"
          class="w-full"
          [options]="baseFluids"
          [formControlName]="form.formControlNames.baseFluid"
          appendTo="body"
          optionLabel="label"
          optionValue="value"
          (onChange)="setDefaultPvYp($event, true)"
        ></p-select>
      </div>

      <div class="flex flex-col">
        <label for="nominalDensity">Nominal Density</label>
        <app-validated-number-input
          [id]="'nominalDensity'"
          [control]="control('nominalDensity')"
          [value]="control('nominalDensity').value"
          [validation]="densityValidation"
          [unit]="densityUnits"
          (onChange)="setDefaultPvYp(null, false)"
        ></app-validated-number-input>
      </div>

      <div class="flex flex-col">
        <label for="densityTemperature">Density Temperature</label>
        <app-validated-number-input
          [id]="'densityTemperature'"
          [control]="control('densityTemperature')"
          [value]="control('densityTemperature').value"
          [validation]="temperatureValidation"
          [unit]="tempUnit">
        </app-validated-number-input>
      </div>
    </div>

    <div class="flex flex-col w-1/2 p-2 space-y-2">

      <div class="flex flex-col">
        <label for="plasticViscosity">Plastic Viscosity</label>
        <app-validated-number-input
          [id]="'plasticViscosity'"
          [control]="control('plasticViscosity')"
          [value]="control('plasticViscosity').value"
          [validation]="pvValidation"
          [unit]="pvUnits">
        </app-validated-number-input>
      </div>

      <div class="flex flex-col">
        <label for="yieldPoint">Yield Point</label>
        <app-validated-number-input
          [id]="'yieldPoint'"
          [control]="control('yieldPoint')"
          [value]="control('yieldPoint').value"
          [validation]="ypValidation"
          [unit]="ypUnits">
        </app-validated-number-input>
      </div>

      <div class="flex flex-col">
        <label for="rheologyTemperature">Rheology Temperature</label>
        <app-validated-number-input
          [id]="'rheologyTemperature'"
          [control]="control('rheologyTemperature')"
          [value]="control('rheologyTemperature').value"
          [validation]="temperatureValidation"
          [unit]="tempUnit">
        </app-validated-number-input>
      </div>

    </div>
  </div>

</form>
